export default "__VITE_ASSET__BR8FA59p__"